import * as React from 'react';
import { connect } from 'react-redux';
import store from '@/redux/index';
import { types, IExpertEditStoreState } from '@/redux/pages/expert-edit';

const Toast = require('react-toast-mobile');

class GoodAt extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            field1: this.props.field[0] || '', // 领域1
            field2: this.props.field[1] || '', // 领域2
            field3: this.props.field[2] || '', // 领域3
        };
    }

    public render() {
        const state = this.state;
        return (
            <section>
                <div className="goodat-form">
                    <div className="goodat-item">
                        1.<input type="text" placeholder="请输入" onChange={() => this.inputAction('field1')} value={state.field1} />
                    </div>
                    <div className="goodat-item">
                        2.<input type="text" placeholder="请输入" onChange={() => this.inputAction('field2')} value={state.field2} />
                    </div>
                    <div className="goodat-item">
                        3.<input type="text" placeholder="请输入" onChange={() => this.inputAction('field3')} value={state.field3} />
                    </div>
                </div>
                <div className="goodat-btns"><button className="btn-submit" onClick={() => { this.submitAction() }}>确定</button></div>
            </section>
        )
    }

    /**
     * 输入框
     * @param modelName {string} 模块名称
     */
    private inputAction(modelName: string) { 
        this.setState({
            [modelName]: (event as any).target.value
        });
    }
    
    // 提交
    private submitAction() { 
        if (this.state.field1 === '' && this.state.field2 === '' && this.state.field3 === '') {
            return Toast.T.notify('最少填写一个领域');
        } else if (this.state.field1.length > 30) { 
            return Toast.T.notify('领域1最多只能填写30个字');
        } else if (this.state.field2.length > 30) { 
            return Toast.T.notify('领域2最多只能填写30个字');
        } else if (this.state.field3.length > 30) { 
            return Toast.T.notify('领域3最多只能填写30个字');
        }
        store.dispatch({
            type: types.INPUT,
            data: {
                key: 'field',
                value: [
                    this.state.field1,
                    this.state.field2,
                    this.state.field3
                ]
            }
        });
        this.props.history.goBack();
    }
}

const mapStateToProps = (state: any): IExpertEditStoreState => { 
    return {
        ...state.expertEditReducers
    }
}

export default connect(mapStateToProps)(GoodAt);